import { I18n } from "@assets/strings";
import React from "react";
import { ClipLoader } from "react-spinners";
import { usePost } from "@domain/post/hooks";
import { useIsMobile } from "@utils/hooks";
import { NotFoundPage } from "@ui/pages/notFoundPage";
import { PostPageMobile } from "./postPageMobile";
import { PostPageWeb } from "./postPageWeb";

interface PostPageProps extends React.HTMLAttributes<HTMLDivElement> {
	postId: string;
}

export const PostPage: React.FC<PostPageProps> = ({ postId }) => {
	const { result: post, loading, error } = usePost(postId);

	const isMobile = useIsMobile();

	if (error?.code === 404) {
		return <NotFoundPage message={I18n.t("404.post")} />;
	}
	if (!post) {
		return loading ? <ClipLoader /> : null;
	}

	return isMobile ? <PostPageMobile post={post} /> : <PostPageWeb post={post} />;
};
